export default __webpack_public_path__ + "static/sportspullen-fb370c04c90c3e314cf15cad3eb60547.jpg";